import React from 'react'
import {useParams} from "react-router";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import AsyncBlock from "../../components/forms/AsyncBlock";
import {errorToast, successToast} from "../../components/layout/ToastStyles";
import {Apis} from "../../util/data";
import PageContainer from "../../components/layout/PageContainer";
import PageSection from "../../components/layout/PageSection";
import {PageBackLabel} from "../../components/layout/PageBackLabel";
import PageTitle from "../../components/layout/PageTitle";
import useFetch2 from "../../hooks/useFetch2";
import ConsejeriaForm from "./ConsejeriaForm";

const ConsejeriaEdit = () => {

  const navigate = useNavigate()

  const {id} = useParams()
  const {data, loading, fetchData, error} = useFetch2(Apis.PROD + '/consejeria/' + id, {});

  const onUpdate = (consej) => {
    consej.id = id;
    axios.put(Apis.PROD + '/consejeria/update/' + id, consej)
      .then(res => {
        successToast("Consejeria actualizada correctamente")
        navigate('/consejerias')
      })
      .catch(err => {
        errorToast(err.response.data.message, 6000)
      });
  }

  return (
    <PageContainer>
      <PageSection>
        <PageBackLabel text='Consejerias' onClick={() => navigate('/consejerias')}/>
        <PageTitle title={data.nombre}/>
      </PageSection>

      <PageSection>
        <AsyncBlock loading={loading} error={error}>
          <ConsejeriaForm value={data} onSubmit={(consej) => onUpdate(consej)}/>
        </AsyncBlock>

      </PageSection>
    </PageContainer>
  )
}

export default ConsejeriaEdit;
